module.exports = __webpack_public_path__ + "media/assets/icons/ic-chevron-up-7f093b5bd8106f0ce127cb7b702c1152.svg";